// import router from "router";
// import JwtService from "core/services/jwt.service";
import Vue from "vue";
import { ir } from "./check_domain_ir";
import JwtService from "./core/plugins/TitleRibbon/assets/js/jwt.service";
import router from "./router";
import money from "./Mony.json";
// import service from "./service.json";
import serviceTickets from "./serviceTickets.json";
import { LOGOUT } from "@/core/services/store/auth.module";
import store from "@/core/services/store";
import { mapGetters } from "vuex";
import { VueReCaptcha } from "vue-recaptcha-v3";
import i18n from "./i18n";

// https://www.robat-land.ir
let coreland = ir(process.env.VUE_APP_CoreLandUrl);
// let payamakland="http://127.0.0.1:8001"
let payamakland = ir("https://sms-api.terminalads.com"); // process.env.VUE_APP_PayamakLandURL
let robatland = ir(process.env.VUE_APP_RobatLandURL);
let realState = ir(process.env.VUE_APP_RealStateURL);
let coreWalelt = ir(process.env.VUE_APP_CoreWalletUrl);

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA3_SITE,
     loaderOptions: {
    useRecaptchaNet: true, 
    autoHideBadge: true,
     renderParameters: {
      render: "explicit",
    },
  },

 });
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

Array.prototype.removeDuplicateInArray = function (target) {
  const uniqueTags = new Map(this.map((item) => [item[target], item]));
  return [...uniqueTags.values()];
};

const Mixin = {
  mounted() {
    $("input[name='table-search']")
      .parent()
      .removeClass("offset-md-6")
      .addClass("ms-auto");
  },
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters("ribbon", ["new_wallet"]),
    wallet() {
      return this.new_wallet;
    },
    translates() {
      return {
        nextButton: "بعدی",
        previousButton: "قبلی",
        rowsPerPageText: "تعداد در صفحه",
        noDataText: "داده ای برای نمایش وجود ندارد",
        placeholderSearch: "جستجو",
      };
    },
    perPages() {
      return [10, 25, 50, 100, 200, 400];
    },
  },
  methods: {
    ir(url) {
      return ir(url);
    },
    isNumericKey(evt) {
      let persianChars = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        (charCode < 96 || charCode > 105) &&
        persianChars.indexOf(evt.key) === -1
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isStringKey(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        !((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105))
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    datediff(first, second) {
      return Math.round((second - first) / (1000 * 60 * 60 * 24));
    },
    async generateRecaptchaToken(action) {
      await this.$recaptchaLoaded();
      return await this.$recaptcha(action);
    },
    coreLandApi(url) {
      return coreland + `/storage/${url}`;
    },
    setFirstLogin() {
      window.localStorage.setItem("firstLogin", true);
    },
    toggleNavigation() {
      this.$store.dispatch("menu/toggle");
    },
    toggleMobileMenu() {
      this.$store.dispatch("menu/toggle");
      // this.$store.dispatch('menu/toggleMobile');
    },
    cloneObject(obj) {
      return JSON.parse(JSON.stringify(obj));
    },
    firstLetter(input) {
      if (!input) return "U";
      return input.charAt(0).toUpperCase().toString();
    },
    // summary(input){
    //     return input.substring(0,2)+'...'
    // },
    async getUserTokenWithId(id) {
      let response = await this.requestApiPost("admin/userLogin", {
        user_id: id,
      });
      if (response.data.token) {
        return response.data.token;
      } else {
        throw new DOMException("to token found");
      }
    },
    authority() {
      this.requestApiGet("user")
        .then(({ data }) => {
          localStorage.setItem("userInfo", JSON.stringify(data));
          store.dispatch("setUser", data);
        })
        .catch(({ response }) => {
          if (response.status === 401) {
            this.logout();
          }
        });
    },
    logout() {
      this.$toast.warning("لطفا وارد شوید");
      return this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
    },
    configurationFile() {
      return {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: function (progressEvent) {
          this.progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          this.$forceUpdate();
        }.bind(this),
      };
    },
    getTime: function (input) {
      try {
        let time = input.split(" ")[1].split(":");
        return time[0] + ":" + time[1];
      } catch (e) {
        return input;
      }
    },
    jalalian: function (input) {
      if (!input) return ""; 
      try {
        let moment = require("moment-jalaali");
        let date = moment(input, "YYYY/MM/DD");
        if (!date.isValid()) return input; 
        return date.format("jYYYY/jM/jD");
      } catch (e) {
        return input;
      }},
    datetime(input, type) {
      if (input == null || input.length === 0) return "-";

      if (type === "datetime") {
        return `${this.jalalian(input)} ${this.getTime(input)}`;
      } else {
        return `${this.jalalian(input)}`;
      }
    },
    dateString(input) {
      try {
        let moment = require("moment-jalaali");
        moment.locale("fa", null);
        moment.loadPersian({ dialect: "persian-modern" });
        return moment(input, "YYYY-MM-DD HH:mm:ss").format("dddd LL");
      } catch (e) {}
    },
    openLink(url) {
      let a = document.createElement("a");
      // a.target = '_blank';
      a.href = url;
      a.click();
    },
  async checkTokenAsync(token) {
    try {
      let res = await axios.get(`${this.$sarveLand}/api/user`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.status === 200) {
        
        try {
          let resValid = await axios.get(`${this.$sarveLand}/api/user/validation`, {
            headers: { Authorization: `Bearer ${token}` },
          });
          
          if (resValid.status === 200) {
            localStorage.setItem("user_info", JSON.stringify(res.data));
            this.$store.dispatch("setUser", res.data);
          }
        } catch (validError) {
          if (validError.response && validError.response.status === 400) {
            this.$root.$emit("open-address-popup");
          } 
          else if (validError.response && validError.response.status === 401) {
            throw validError; 
          }
        }

    }
  } catch (e) {
    if (e.response && e.response.status === 401) {
      this.$store
        .dispatch(LOGOUT)
        .then(() => window.location.replace(`${this.$sarveLandFront}`));
    }
  }
},

    async checkWalletAsync() {
      const vm = this;
      let walletInfo = "";

      try {
        let data = await axios.post(
          `${this.ir(process.env.VUE_APP_CoreLandUrl) + "/api/wallet"}`,
          {},
          {
            headers: this.header(),
          }
        );
        data = data.data;

        if (data.currency === "Rial") {
          walletInfo = this.changeMoney("rial");
        }
        if (data.currency === "Toman") {
          walletInfo = this.changeMoney("toman");
        }                // this.$toast.error(resValid.response.message,{
                // timeout: 5000,
                // });

        if (data.currency === "Dollar") {
          walletInfo = this.changeMoney("dollar");
        }
        if (data.currency === "Euro") {
          walletInfo = this.changeMoney("euro");
        }
        if (data.currency === "Bitcoin") {
          walletInfo = this.changeMoney("bitcoin");
        }
        if (data.currency === "Ethereum") {
          walletInfo = this.changeMoney("ethereum");
        }
        let user_wallet = {
          icon: walletInfo.icon,
          color: walletInfo.color,
          balance: data.balance,
        };
        localStorage.setItem("user_wallet", JSON.stringify(user_wallet));
        this.$store.dispatch("wallet/setWallet", user_wallet);
      } catch (e) {}
    },
    async getSpecialmenu() {
      try {
        let data = await this.requestApiGet("category/special");
        this.$store.dispatch("menu/items", data.data);
      } catch (e) {}
    },
    isNumberKey: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    async getService() {
      const { data } = await this.requestApiGet("getServices");
      const services = data.services.map((item) => ({
        id: item.id,
        nameLand: item.nameLand,
      }));
      console.log(services, "services1");
      return services;
    },
    // getService() {
    //   return service;
    // },
    getServiceTicket() {
      return serviceTickets;
    },
    getUserStatus() {
      let status = this.getUser();
      return status.auth_validate;
    },
    getUser() {
      //TODO: delete id and private fields
      return JSON.parse(localStorage.getItem("user_info"));
    },
    getWallet() {
      return JSON.parse(localStorage.getItem("user_wallet"));
    },
    checkWallet() {
      let walletInfo = "";
      axios
        .post(
          coreland + "/api/wallet",
          {},
          {
            headers: this.header(),
          }
        )
        .then(({ data }) => {
          if (data.currency === "Rial") {
            walletInfo = this.changeMoney("rial");
          }
          if (data.currency === "Toman") {
            walletInfo = this.changeMoney("toman");
          }
          if (data.currency === "Dollar") {
            walletInfo = this.changeMoney("dollar");
          }
          if (data.currency === "Euro") {
            walletInfo = this.changeMoney("euro");
          }
          if (data.currency === "Bitcoin") {
            walletInfo = this.changeMoney("bitcoin");
          }
          if (data.currency === "Ethereum") {
            walletInfo = this.changeMoney("ethereum");
          }
          let user_wallet = {
            icon: walletInfo.icon,
            color: walletInfo.color,
            balance: data.balance,
          };
          localStorage.setItem("user_wallet", JSON.stringify(user_wallet));
          this.$store.dispatch("wallet/setWallet", user_wallet);
        })
        .catch(({ response }) => {
          if (response.status === 401) {
            this.logout();
          }
        });
    },
    changeMoney(data) {
      return {
        icon: money.data[data].icon,
        color: money.data[data].color,
        value: money.data[data].value,
      };
    },
    goto(route, query = {}) {
      router.push({ path: "/" + route, query: query });
    },
    goReplace(route) {
      router.replace({ path: "/" + route });
    },
    toggleNightMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.setCookie("theme", this.$vuetify.theme.dark, "60");
    },
    setCookie(cname, cvalue, exdays) {
      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname, def = "") {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return def;
    },
    header() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };
    },
    StateHeader() {
      return {
        Authorization: JwtService.getToken() ?? null, // Authorization: `Bearer ` + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5NzBjNGM2MC03NjMxLTQ4YTYtYWYzOS02MmY0Y2Q4NGVjMTkiLCJqdGkiOiI5ZWEyMWEwZDVlOGY0NWFmYWQ0ODUzMWZjOGM4OGM4ZDZmMzY1NDRiNTRlODVkMTE4NjdjMGRhM2YyOWVhMDMyMDhlZmE3NmQ2ZmZmYjVkZSIsImlhdCI6MTY3ODYzMDkwMi4zNTIwODIsIm5iZiI6MTY3ODYzMDkwMi4zNTIwOSwiZXhwIjoxNjc5OTIzMzAyLjM0NzI2Nywic3ViIjoiMyIsInNjb3BlcyI6W119.qjAV9IcUzzYsuNzLlUOz5sHFnzXUdFctrpSzsi4sY87gYqpnWvgwcSWFVtq6X6vtN2aW_mU_5XdzOLxw_KhVubXcdcMZE9HXzSNpxCT3TNCeDyyalRzhqJGIOjTE-zH4rt5lu49Q9Krm1On6bM8y36AsalDQQw2b7jrAWInHC1UQ5zAH4efiGWvNiJwz8FW20dmllAR1ibw29feyU-oQCu9uorbn5qxGnYJXs6gEl64gtb5Sw4Ne_zMEPi9tV_D2dub_220bjr4qeqA4F-6C2urptXhgCqWdO_3x2lX2QrkPBZOFTtF4n_zbFMbt8swcgemRnkWSRpo4pTkBP_hIWPrFp3w0tI0UEH-65uI6ASKzXBTRuzaPcl6E7sYvKfJy15yAF-2YYOZRkvrsNE8Xuwq2cyA8Ae6ZmS2JZafvX6lyYm2AP5t67qmT_Yd-tAmTFOJgt8S-xi6L4cF88gOgAaj_7BQJktZarn47U4Ci9N9ldz12CzoPPv9gmjt2yljgMyZgAufuzuXF-7A1icLdyr5wkBjLHKwfLJXumnqh4vflJ7NIjf75GrhTWJwTU3SHNcT_Bwv8OkIEyFTpRDDtd1Wtggv9T8gVKZ3J_ndBx1MmbryYRz2w7BG3fUgUEQChCCUvnjgH6Bh-rqMXjL8fA7V4hLT-WJt6qv2DqnJVY9Q',
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };
    },
    payamakHeader() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null, // Authorization: `Bearer ` + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5NzBjNGM2MC03NjMxLTQ4YTYtYWYzOS02MmY0Y2Q4NGVjMTkiLCJqdGkiOiI5ZWEyMWEwZDVlOGY0NWFmYWQ0ODUzMWZjOGM4OGM4ZDZmMzY1NDRiNTRlODVkMTE4NjdjMGRhM2YyOWVhMDMyMDhlZmE3NmQ2ZmZmYjVkZSIsImlhdCI6MTY3ODYzMDkwMi4zNTIwODIsIm5iZiI6MTY3ODYzMDkwMi4zNTIwOSwiZXhwIjoxNjc5OTIzMzAyLjM0NzI2Nywic3ViIjoiMyIsInNjb3BlcyI6W119.qjAV9IcUzzYsuNzLlUOz5sHFnzXUdFctrpSzsi4sY87gYqpnWvgwcSWFVtq6X6vtN2aW_mU_5XdzOLxw_KhVubXcdcMZE9HXzSNpxCT3TNCeDyyalRzhqJGIOjTE-zH4rt5lu49Q9Krm1On6bM8y36AsalDQQw2b7jrAWInHC1UQ5zAH4efiGWvNiJwz8FW20dmllAR1ibw29feyU-oQCu9uorbn5qxGnYJXs6gEl64gtb5Sw4Ne_zMEPi9tV_D2dub_220bjr4qeqA4F-6C2urptXhgCqWdO_3x2lX2QrkPBZOFTtF4n_zbFMbt8swcgemRnkWSRpo4pTkBP_hIWPrFp3w0tI0UEH-65uI6ASKzXBTRuzaPcl6E7sYvKfJy15yAF-2YYOZRkvrsNE8Xuwq2cyA8Ae6ZmS2JZafvX6lyYm2AP5t67qmT_Yd-tAmTFOJgt8S-xi6L4cF88gOgAaj_7BQJktZarn47U4Ci9N9ldz12CzoPPv9gmjt2yljgMyZgAufuzuXF-7A1icLdyr5wkBjLHKwfLJXumnqh4vflJ7NIjf75GrhTWJwTU3SHNcT_Bwv8OkIEyFTpRDDtd1Wtggv9T8gVKZ3J_ndBx1MmbryYRz2w7BG3fUgUEQChCCUvnjgH6Bh-rqMXjL8fA7V4hLT-WJt6qv2DqnJVY9Q',
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };
    },
    coreWalletHeader() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null,
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };
    },
    rbHeader() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null,
        secret: "",
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };
    },
    stateHeader() {
      return {
        Authorization: JwtService.getToken()
          ? `Bearer ${JwtService.getToken()}`
          : null, // Authorization: `Bearer ` + 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJhdWQiOiI5NzBjNGM2MC03NjMxLTQ4YTYtYWYzOS02MmY0Y2Q4NGVjMTkiLCJqdGkiOiI5ZWEyMWEwZDVlOGY0NWFmYWQ0ODUzMWZjOGM4OGM4ZDZmMzY1NDRiNTRlODVkMTE4NjdjMGRhM2YyOWVhMDMyMDhlZmE3NmQ2ZmZmYjVkZSIsImlhdCI6MTY3ODYzMDkwMi4zNTIwODIsIm5iZiI6MTY3ODYzMDkwMi4zNTIwOSwiZXhwIjoxNjc5OTIzMzAyLjM0NzI2Nywic3ViIjoiMyIsInNjb3BlcyI6W119.qjAV9IcUzzYsuNzLlUOz5sHFnzXUdFctrpSzsi4sY87gYqpnWvgwcSWFVtq6X6vtN2aW_mU_5XdzOLxw_KhVubXcdcMZE9HXzSNpxCT3TNCeDyyalRzhqJGIOjTE-zH4rt5lu49Q9Krm1On6bM8y36AsalDQQw2b7jrAWInHC1UQ5zAH4efiGWvNiJwz8FW20dmllAR1ibw29feyU-oQCu9uorbn5qxGnYJXs6gEl64gtb5Sw4Ne_zMEPi9tV_D2dub_220bjr4qeqA4F-6C2urptXhgCqWdO_3x2lX2QrkPBZOFTtF4n_zbFMbt8swcgemRnkWSRpo4pTkBP_hIWPrFp3w0tI0UEH-65uI6ASKzXBTRuzaPcl6E7sYvKfJy15yAF-2YYOZRkvrsNE8Xuwq2cyA8Ae6ZmS2JZafvX6lyYm2AP5t67qmT_Yd-tAmTFOJgt8S-xi6L4cF88gOgAaj_7BQJktZarn47U4Ci9N9ldz12CzoPPv9gmjt2yljgMyZgAufuzuXF-7A1icLdyr5wkBjLHKwfLJXumnqh4vflJ7NIjf75GrhTWJwTU3SHNcT_Bwv8OkIEyFTpRDDtd1Wtggv9T8gVKZ3J_ndBx1MmbryYRz2w7BG3fUgUEQChCCUvnjgH6Bh-rqMXjL8fA7V4hLT-WJt6qv2DqnJVY9Q',
        Accept: "application/json",
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
      };
    },
    requestApiGetWallet(uri, queries = {}) {
      return axios.get(`${coreWalelt + "/api"}/${uri}`, {
        headers: this.coreWalletHeader(),
        params: queries,
      });
    },
    requestApiPostWallet(uri, data = {}) {
      return axios.post(`${coreWalelt + "/api"}/${uri}`, data, {
        headers: this.coreWalletHeader(),
      });
    },
    requestApiGet(uri, queries = {}) {
      return axios.get(`${coreland + "/api"}/${uri}`, {
        headers: this.header(),
        params: queries,
      });
    },
    requestApiGetPayamak(uri, queries = {}) {
      return axios.get(`${payamakland + "/api"}/${uri}`, {
        headers: this.payamakHeader(),
        params: queries,
      });
    },
    requestApiPostPayamak(uri, data = {}) {
      return axios.post(`${payamakland + "/api"}/${uri}`, data, {
        headers: this.payamakHeader(),
      });
    },
    requestApiDeletePayamak(uri, queries = {}) {
      return axios.delete(`${payamakland + "/api"}/${uri}`, {
        headers: this.header(),
        params: queries,
      });
    },
    requestApiGetState(uri, queries = {}) {
      return axios.get(`${realState + "/api"}/${uri}`, {
        headers: this.StateHeader(),
        params: queries,
      });
    },
    requestApiPostState(uri, data = {}) {
      return axios.post(`${realState + "/api"}/${uri}`, data, {
        headers: this.StateHeader(),
      });
    },
    requestApiPostًًRbًً(uri, data = {}) {
      return axios.post(`${robatland + "/api"}/${uri}`, data, {
        headers: this.payamakHeader(),
      });
    },
    requestApiGetRb(uri, queries = {}) {
      return axios.get(`${robatland + "/api"}/${uri}`, {
        headers: this.payamakHeader(),
        params: queries,
      });
    },
    requestApiPost(uri, data = {}) {
      return axios.post(`${coreland + "/api"}/${uri}`, data, {
        headers: this.header(),
      });
    },
    requestApiPostLogin(uri, data = {}) {
      return axios.post(`${coreland + "/api"}/${uri}`, data);
    },
    requestApiPut(uri, data = {}, queries = {}) {
      return axios.put(`${coreland + "/api"}/${uri}`, data, {
        headers: this.header(),
        params: queries,
      });
    },
    //
    requestApiDelete(uri, queries = {}) {
      return axios.delete(`${coreland + "/api"}/${uri}`, {
        headers: this.header(),
        params: queries,
      });
    },

    validateInput(input) {
      if (input === undefined || input == null) return "";
      let str = input.toString().trim();
      if (str === "") return "";
      return str;
    },

    use_lang(input) {
      let lang = i18n.locale || "fa";
      let str1 = this.validateInput(input);
      if (typeof str1 !== "string") str1 = str1 == null ? "0" : str1.toString();
      switch (lang) {
        case "fa":
          str1 = this.persian(str1);
          break;
        case "en":
        case "en_US":
          str1 = this.english(str1);
          break;
        case "ar":
          str1 = this.arabic(str1);
          break;

        default:
          str1 = this.persian(str1);
          break;
      }
      return str1;
    },
    persian(input) {
      let str1 = this.validateInput(input);
      // تبدیل اعداد انگلیسی به فارسی
      str1 = str1.replace(/0/gim, "۰");
      str1 = str1.replace(/1/gim, "۱");
      str1 = str1.replace(/2/gim, "۲");
      str1 = str1.replace(/3/gim, "۳");
      str1 = str1.replace(/4/gim, "۴");
      str1 = str1.replace(/5/gim, "۵");
      str1 = str1.replace(/6/gim, "۶");
      str1 = str1.replace(/7/gim, "۷");
      str1 = str1.replace(/8/gim, "۸");
      str1 = str1.replace(/9/gim, "۹");
      // تبدیل اعداد عربی به فارسی
      str1 = str1.replace(/٠/gim, "۰");
      str1 = str1.replace(/١/gim, "۱");
      str1 = str1.replace(/٢/gim, "۲");
      str1 = str1.replace(/٣/gim, "۳");
      str1 = str1.replace(/٤/gim, "۴");
      str1 = str1.replace(/٥/gim, "۵");
      str1 = str1.replace(/٦/gim, "۶");
      str1 = str1.replace(/٧/gim, "۷");
      str1 = str1.replace(/٨/gim, "۸");
      str1 = str1.replace(/٩/gim, "۹");
      return str1;
    },

    english(input) {
      let str1 = this.validateInput(input);
      // تبدیل اعداد فارسی به انگلیسی
      str1 = str1.replace(/۰/gim, "0");
      str1 = str1.replace(/۱/gim, "1");
      str1 = str1.replace(/۲/gim, "2");
      str1 = str1.replace(/۳/gim, "3");
      str1 = str1.replace(/۴/gim, "4");
      str1 = str1.replace(/۵/gim, "5");
      str1 = str1.replace(/۶/gim, "6");
      str1 = str1.replace(/۷/gim, "7");
      str1 = str1.replace(/۸/gim, "8");
      str1 = str1.replace(/۹/gim, "9");
      // تبدیل اعداد عربی به انگلیسی
      str1 = str1.replace(/٠/gim, "0");
      str1 = str1.replace(/١/gim, "1");
      str1 = str1.replace(/٢/gim, "2");
      str1 = str1.replace(/٣/gim, "3");
      str1 = str1.replace(/٤/gim, "4");
      str1 = str1.replace(/٥/gim, "5");
      str1 = str1.replace(/٦/gim, "6");
      str1 = str1.replace(/٧/gim, "7");
      str1 = str1.replace(/٨/gim, "8");
      str1 = str1.replace(/٩/gim, "9");
      return str1;
    },

    arabic(input) {
      let str1 = this.validateInput(input);
      // تبدیل اعداد انگلیسی به عربی
      str1 = str1.replace(/0/gim, "٠");
      str1 = str1.replace(/1/gim, "١");
      str1 = str1.replace(/2/gim, "٢");
      str1 = str1.replace(/3/gim, "٣");
      str1 = str1.replace(/4/gim, "٤");
      str1 = str1.replace(/5/gim, "٥");
      str1 = str1.replace(/6/gim, "٦");
      str1 = str1.replace(/7/gim, "٧");
      str1 = str1.replace(/8/gim, "٨");
      str1 = str1.replace(/9/gim, "٩");
      // تبدیل اعداد فارسی به عربی
      str1 = str1.replace(/۰/gim, "٠");
      str1 = str1.replace(/۱/gim, "١");
      str1 = str1.replace(/۲/gim, "٢");
      str1 = str1.replace(/۳/gim, "٣");
      str1 = str1.replace(/۴/gim, "٤");
      str1 = str1.replace(/۵/gim, "٥");
      str1 = str1.replace(/۶/gim, "٦");
      str1 = str1.replace(/۷/gim, "٧");
      str1 = str1.replace(/۸/gim, "٨");
      str1 = str1.replace(/۹/gim, "٩");
      return str1;
    },
    setBreadcrumb(title) {
      this.$store.dispatch(SET_BREADCRUMB, [{ title }]);
    },
    english(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/۰/gim, "0");
      str1 = str1.replace(/۱/gim, "1");
      str1 = str1.replace(/۲/gim, "2");
      str1 = str1.replace(/۳/gim, "3");
      str1 = str1.replace(/۴/gim, "4");
      str1 = str1.replace(/۵/gim, "5");
      str1 = str1.replace(/۶/gim, "6");
      str1 = str1.replace(/۷/gim, "7");
      str1 = str1.replace(/۸/gim, "8");
      str1 = str1.replace(/۹/gim, "9");
      return str1;
    },
    objectLength(obj) {
      try {
        return Object.keys(obj).length;
      } catch (e) {}
    },
    validatePhone(input) {
      let message = "";

      if (
        !/^[\+]?[(]?[0][-\s\.]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im.test(
          input.phone
        )
      ) {
        message = "فیلد تلفن همراه را صحیح وارد نمایید!";
      } else {
        return true;
      }

      return false;
    },
    coreLandUrl(url) {
      return coreland + `/${url}`;
    },
    price: function (input) {
      try {
        return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } catch (e) {
        return input;
      }
    },
    priceLimit: function (input) {
      try {
        // input=input.toFixed(2)
        // return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
        return input.toFixed(2);
      } catch (e) {
        return input;
      }
    },
    unprice: function (input) {
      try {
        return input.replace(/,/g, "");
      } catch (e) {
        return input;
      }
    },
    permissionStatus(permissionName) {
      this.requestApiPost("abilitiesStatus", { name: permissionName }).then(
        (response) => {
          if (response.data === "show") {
            // window.alert('شما به این بخش دسترسی ندارید!');
            return false;
          }
          // window.alert('done')
          return true;
          // return response.data
        }
      );
    },
    nowDateTimeString() {
      const t = new Date();
      const date = ("0" + t.getDate()).slice(-2);
      const month = ("0" + (t.getMonth() + 1)).slice(-2);
      const year = t.getFullYear();
      const hours = ("0" + t.getHours()).slice(-2);
      const minutes = ("0" + t.getMinutes()).slice(-2);
      const seconds = ("0" + t.getSeconds()).slice(-2);
      return this.jalalian(`${year}/${month}/${date}`) + ` ${hours}:${minutes}`;
    },
    copyLink(str, isLink = true) {
      let link = str;

      if (!link.startsWith("http") && isLink) link = "https://" + link;

      try {
        if (!!navigator.clipboard) navigator.clipboard.writeText(link);
        else {
          let textArea = document.createElement("textarea");
          textArea.value = link;

          // Avoid scrolling to bottom
          textArea.style.top = "0";
          textArea.style.left = "0";
          textArea.style.position = "fixed";

          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();

          try {
            let successful = document.execCommand("copy");
            let msg = successful ? "successful" : "unsuccessful";
            console.log("Fallback: Copying text command was " + msg);
          } catch (err) {
            console.error("Fallback: Oops, unable to copy", err);
            this.$toast.error("خطا در رونوشت لینک.");
          }

          document.body.removeChild(textArea);
        }
      } catch (e) {
        this.$toast.error("خطا در رونوشت لینک.");
      }

      this.$toast.info("لینک کپی شد.");
    },
    hasPhonebookPermission(value, target = null) {
      let p;

      if (!!target)
        p = this.isInShareListPhonebook(target) ? target.setting : true;
      else p = this.$store.getters["phonebook/phonebookPermissions"];

      return typeof p === "object" ? p[value] : true;
    },
    isInShareListPhonebook(target) {
      return target.hasOwnProperty("parent_id");
    },
  },
};

export { Mixin };

export default {
  install(Vue, options) {
    Vue.mixin(Mixin);
  },
};
